export const CATEGORY_SUMMARIES_LOADED = 'bookings/CATEGORY_SUMMARIES_LOADED';

export const initialState = {
    categorySummaries: false,
};

export const categorySummariesLoaded = (categorySummaries) => ({
    type: CATEGORY_SUMMARIES_LOADED,
    payload: {
        categorySummaries: categorySummaries
    }
})

export const LocalReducer = (state = initialState, action) => {
    switch (action.type) {
        case CATEGORY_SUMMARIES_LOADED: {
            return {
                ...state,
                categorySummaries: action.payload.categorySummaries
            }
        }

        default:
            return state;
    }
}
